<template>
  <div class="container last-page winner">
    <div class="content">
      <div class="header">
        <p>Stap 3 / 3</p>
        <h1><strong>Hoera!!<br/>Je wint een iPad!!</strong></h1>
      </div>
      <div class="group">
        <span class="emoji">🎉🎉🎉</span>
        <p>Neem contact op met één van onze medewerkers.</p>
        <ck-progressbar class="small" :max="maxSeconds" :value="secondsLeft" />
      </div>
      <div class="group">
        <p>Het Quality Guard Team</p>
        <img class="img-logo" alt="Logo Quality Guard" src="~@/assets/images/logo-white.png">
      </div>
    </div>
  </div>
</template>

<script>
import timerPage from "@/mixins/timer_page";

export default {
    mixins: [timerPage]
};
</script>
